import Button from "@components/Button";
import { useGetPatientVisit } from "@app/services/omr-service";
import { formatNumber } from "@app/utils";
import Input from "@app/components/Input";
import Label from "@app/components/Label";
import TextArea from "@app/components/TextArea";
import InputDate from "@app/components/InputDate";
import { useState } from "react";

// const InputFileCustom = () => {
//   const [files, setFiles] = useState([]);

//   return (
//     <div className="bg-white p-1.5 focus:border border-blueGray-300 border-2 rounded text-gray-800">
//       <input type="file" className="appearance-none text-sm text-gray-800" />
//     </div>
//   );
// };

export const AddBanner = () => {
  const { data, isFetching, isLoading, payload, setPayload, refetch } =
    useGetPatientVisit({ patient_type: "out-patient" });
  const [selectedDay, setSelectedDay] = useState(null);

  return (
    <div>
      <div className="flex flex-row">
        <h1 className="text-2xl">Tambah Banner</h1>
      </div>
      <div className="mt-6 border-2 border-gray-300 rounded-xl px-4 py-6">
        <div className="grid grid-cols-3 gap-5">
          <div>
            <Label size="sm" font="bold">
              Nama Banner
            </Label>
            <Input placeholder="Masukkan Nama Banner" />
          </div>
          <div>
            <Label size="sm" font="bold">
              Foto Banner
            </Label>
            {/* <InputFileCustom /> */}
            <Input placeholder="Masukkan Nama Banner" type="file" />
          </div>
          <div>
            <Label size="sm" font="bold">
              Alamat URL
            </Label>
            <Input placeholder="Masukkan Alamat URL" />
          </div>
          <div>
            <Label size="sm" font="bold">
              Detail Banner
            </Label>
            <TextArea rows="5" placeholder="Masukkan Detail Banner"></TextArea>
          </div>
          <div>
            <Label size="sm" font="bold">
              Tanggal Kadaluarsa
            </Label>
            <InputDate
              value={selectedDay}
              onChange={setSelectedDay}
              placeholder="Tanggal Kadaluarsa"
              shouldHighlightWeekends
            />
          </div>
        </div>
        {/* //! end grid */}

        <div className="flex flex-row-reverse mt-4">
          <div className="flex flex-row">
            <div className="mr-3 w-[130px] ">
              <Button
                variant="outline"
                color="red"
                block
                onClick={() => alert()}
              >
                Batal
              </Button>
            </div>
            <div className=" w-[130px]">
              <Button
                variant="solid"
                color="blue"
                block
                onClick={() => alert()}
              >
                Simpan
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row-reverse mt-4">
        <div className="flex flex-row">
          <div className="mr-3 w-[160px] ">
            <Button variant="outline" color="red" block onClick={() => alert()}>
              Unpublish
            </Button>
          </div>
          <div className=" w-[160px]">
            <Button variant="solid" color="blue" block onClick={() => alert()}>
              Publish
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
``;
